module.exports = __webpack_public_path__ + "static/media/station_nyarutarama3.c4664736.jpeg";